import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CoursesService } from 'src/app/services/courses.service';
import { DataCourse } from 'src/app/shared/interfaces/course.interface';
import { DataModule } from 'src/app/shared/interfaces/module.interface';
import { DataLesson } from 'src/app/shared/interfaces/lesson.interface';
import { ModulesService } from 'src/app/services/modules.service';
import { ContentService } from 'src/app/services/content.service';
import { LessonsService } from 'src/app/services/lessons.service';
import { combineLatest, filter, forkJoin, map, switchMap, tap, Subscription, Subject, takeUntil } from 'rxjs';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { LoaderComponent } from "../loader/loader.component";


@Component({
    selector: 'app-menu-module-course',
    standalone: true,
    templateUrl: './menu-module-course.component.html',
    styleUrls: ['./menu-module-course.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                height: '*',
                opacity: 1
            })),
            state('closed', style({
                height: '0',
                opacity: 0,
                overflow: 'hidden'
            })),
            transition('open <=> closed', [
                animate('0.6s')
            ])
        ])
    ],
    imports: [CommonModule, RouterModule, LoaderComponent]
})

export class MenuModuleCourseComponent{
  isLoading: boolean = true;
  evaluationPassed: boolean[] = [];
  course:DataCourse | undefined;
  lengthActivities:number = 0;
  currentCourse: DataCourse | undefined;
  modules: DataModule[] = [];
  user:any;
  modulesCurrentCourse: DataModule[] = [];
  lessons: any[][] = [];
  lessonsCurrentCourse: any;
  evaluations: any = [];
  submenuAbierto: number | null = null;
  progress: number = 0;
  destroy$: Subject<boolean> = new Subject<boolean>();
  onUpdateLocalLessonStatusSub : Subscription;
  updatePercent : Subscription;
  evaluationStatus: Subscription;

  constructor(
    private route: ActivatedRoute,
    public content:ContentService,
    private coursesService: CoursesService,
    private modulesService: ModulesService,
    private lessonsService: LessonsService,
    private contentService: ContentService,
    private localStorage: LocalstorageService,
  ) {
      this.onUpdateLocalLessonStatusSub = this.lessonsService.onUpdateLocalLessonCheckedStatus$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: $event => {
            this.onUpdateLessonStatus($event);
          },
          error: error => {
            console.error('Error actualizando el estado de la lección', error);
          }
        }
      );

      this.updatePercent = this.lessonsService.onUpdateLocalLessonLoadPercent$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: $event => {
            this.updatePercentInMenu($event);
          },
          error: error => {
            console.error('Error actualizando el porcentaje del curso', error);
          }
        }
      );

      this.evaluationStatus = this.lessonsService.evaluationStatus$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: () => {
          },
          error: error => {
            console.error('Error actualizando el estado de la evaluacion', error);
          }
        }
      );
    }

    ngOnInit() {
      this.user = this.localStorage.getCurrentUserAsJson();
      this.route.paramMap.pipe(
        map(params => `/${params.get('course-name')}`),
        filter(URL => !!URL),
        switchMap(URL => this.contentService.getIdByPath(URL)),
        tap(id => {
          //Trayendo el curso
          this.coursesService.getCourseById(id).pipe(
            takeUntil(this.destroy$),
            tap(course => {
              this.course = course;
              this.localStorage.setCourseInfo(this.course);
              this.coursesService.courseMenu = this.course;
              this.contentService.getCourseProgress(this.course?.attributes.drupal_internal__nid, this.user.uid).pipe(
                takeUntil(this.destroy$),
                tap(progress => {
                    const dataToSend = {
                        percentage: Math.round(progress.advance),
                        course: this.course
                    };
                    this.lessonsService.onUpdateLocalLessonLoadPercent$.next(dataToSend);
                })
              ).subscribe(
                {
                  error: error => {
                    console.error('Error trayendo el porcentaje del curso', error)
                  }
                }
              );
            })
          ).subscribe(
            {
              error: error => {
                console.error('Error trayendo el curso por id', error)
              }
            }
          );
          //Trayendo módulos del curso
          this.modulesService.getModulesOfCourseById(id).pipe(
            takeUntil(this.destroy$),
            tap(modules => {
              this.modules = modules;
              this.modulesService.modules = this.modules;
              this.localStorage.setModulesInfo(this.modules);

              modules.forEach((module, i) => {
                this.contentService.getFileContent(module.relationships.field_image.data?.id).pipe(
                  takeUntil(this.destroy$),
                  tap(image => module.image = image)
                ).subscribe(
                  {
                    error: error => {
                      console.error('Error trayendo la imagen del módulo', error)
                    }
                  }
                );
                const moduleId = module.id;
                combineLatest([
                  this.lessonsService.getLessonsOfModuleById(moduleId),
                  this.contentService.getEvaluationOfModuleById(moduleId)
                ]).pipe(
                  takeUntil(this.destroy$),
                  tap(([lessons, evaluation]) => {
                    console.log(evaluation);
                    this.evaluations[i] = evaluation;
                    this.evaluations.forEach((evaluation:any, i:number) => {
                      this.statusEvaluation(this.user.uid, evaluation.length ? evaluation[0].attributes.drupal_internal__nid : null, i);
                      // elements.forEach((evaluation:any) => {
                      // })
                    });
                    this.contentService.evaluations[i] = evaluation;
                    //Operando con las lecciones
                    lessons.forEach(lesson => {
                      this.contentService.getLessonview(this.user.uid, lesson.attributes.drupal_internal__nid).pipe(
                        takeUntil(this.destroy$),
                        tap(state => lesson.checked = !!state.length),
                        switchMap(() => this.contentService.getFileContent(lesson.relationships.field_image.data?.id)),
                        tap(image => {
                          lesson.image = image;
                          this.lengthActivities = Number(localStorage.getItem('activitiesLength')) || 0;
                        }),
                        switchMap(() => {
                          return forkJoin({
                            activities: this.content.getActivitiesByLessonId(lesson.id),
                            materials: this.content.getMaterialsByLessonId(lesson.id)
                          });
                        }),
                        tap(results => {
                          lesson.hasActivities = results.activities && results.activities.length > 0;
                          lesson.hasMaterials = results.materials && results.materials.length > 0;
                        })
                      ).subscribe(
                        {
                          error: error => {
                            console.error('Error trayendo el estado de la lección', error);
                          }
                        }
                      );
                    });

                    this.lessons[i] = lessons;

                    this.lessonsService.lessons = this.lessons;
                    this.localStorage.setLessonsInfo(this.lessons);

                  })
                ).subscribe(
                  {
                    error: error => {
                      console.error('Error uniendo las lecciones y la evaluación', error)
                    }
                  }
                );
              });
            })
          ).subscribe(
            {
              error: error => {
                console.error('Error trayendo los módulos del curso', error)
              }
            }
          );
        })
      ).subscribe(
        {
          error: error => {
            console.error('Error leyendo los parámetros de la ruta', error)
          }
        }
      );

      this.localStorage.courseInfo$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: courseInfo => {
            this.currentCourse = courseInfo;
          },
          error: error => {
            console.error('Error trayendo el curso del localStorage', error)
          }
        }
      );
      this.localStorage.modulesInfo$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: modulesInfo => {
            this.modulesCurrentCourse = modulesInfo,
            this.modulesService.modules = this.modulesCurrentCourse;
            console.log("Modules", this.modulesCurrentCourse);
          },
          error: error => {
            console.error('Error trayendo los módulos del localStorage', error)
          }
        }
      );
      this.localStorage.lessonsInfo$.pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: lessonsInfo => this.lessonsCurrentCourse = lessonsInfo,
          error: error => console.error('Error trayendo las lecciones del localStorage', error)
        }
      );
    }

    onUpdateLessonStatus(e:any){
      this.lessonsCurrentCourse.forEach((item: any) => {
        item.forEach((lesson:any) => {
          if(lesson.id === e.id){
            lesson.checked = e.checked;
          }
        })
      });
    }

    updatePercentInMenu(e:any){
      this.progress = e.percentage;
    }

    statusEvaluation(userId:number, evaluationId:number, moduleIndex: number) {
      if(evaluationId != null) {
        this.content.getGradesEvaluation(userId, evaluationId).pipe(takeUntil(this.destroy$)).subscribe({
          next: intents => {
            let passed = false;
            intents.forEach((intent:any) => {
              if (intent.field_rating[0].value >= 80) {
                passed = true;
              }
            });
            this.evaluationPassed[moduleIndex] = passed;
          },
          error: error => console.error('Error trayendo las notas de la evaluación', error)
        });
      } else {
        this.evaluationPassed[moduleIndex] = true;
      }
    }

    isModuleClickable(index: number): boolean {
      if(index === 0) {
        return true;
      }

      return this.evaluationPassed[index - 1];
    }


    toggleSubmenu(index: number) {
      this.submenuAbierto = this.submenuAbierto === index ? null : index;
    }

    lessonIsCompleted(lesson: DataLesson): boolean {
      return lesson.checked === true;
    }

    allLessonsCompleted(index: number): boolean {
      return this.lessonsCurrentCourse[index].every((lesson:any) => lesson.checked);
    }

    toUpperCase(title:string | undefined){
      return title?.toUpperCase();
    }

    ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.complete();
    }

}
